export default __webpack_public_path__ + "static/media/metamask.a739a19a.svg";